module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-搜索-搜索框内置.09edf.png";